import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export default function BottomHeader({ transferProps }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const isActive = (path) => {
        if (path === '/') {
            return location.pathname === path;
        }
        return location.pathname.startsWith(path);
    };
    return (
        <>
            {/* Mobile Bottom Navigation */}
            <nav className="mobile-bottom-nav liquidGlass-wrapper dock notranslate" translate="no">
                <div className="liquidGlass-effect"></div>
                {/* <div className="liquidGlass-tint"></div> */}
                <div className="liquidGlass-shine"></div>

                <div className={`mobile-nav-item ${isActive('/home') ? 'active' : ''}`} onClick={() => navigate('/home')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd"
                            d="M18.7723 6.94675L13.8352 2.8646C12.1721 1.48958 9.82778 1.48958 8.1647 2.8646L3.22747 6.94675C2.33796 7.68221 1.83325 8.7973 1.83325 9.96078V16.3267C1.83325 18.3938 3.42289 20.1667 5.49992 20.1667H7.33325C8.34577 20.1667 9.16659 19.3459 9.16659 18.3333V15.3522C9.16659 14.1903 10.0393 13.3455 10.9999 13.3455C11.9605 13.3455 12.8333 14.1903 12.8333 15.3522V18.3333C12.8333 19.3459 13.654 20.1667 14.6666 20.1667H16.4999C18.577 20.1667 20.1666 18.3938 20.1666 16.3267V9.96078C20.1666 8.79731 19.6619 7.68221 18.7723 6.94675Z"
                            fill="black" fillOpacity="0.35" />
                    </svg>
                    <span>{t('home')}</span>
                </div>
                <div className={`mobile-nav-item ${isActive('/profile') ? 'active' : ''}`} onClick={() => navigate('/profile')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path
                            d="M11.0001 10.8129C13.4925 10.8129 15.513 8.80278 15.513 6.32313C15.513 3.84348 13.4925 1.83333 11.0001 1.83333C8.50777 1.83333 6.4873 3.84348 6.4873 6.32313C6.4873 8.80278 8.50777 10.8129 11.0001 10.8129Z"
                            fill="black" fillOpacity="0.35" />
                        <path
                            d="M13.3505 12.6837H8.64966C5.92316 12.6837 3.66675 14.9287 3.66675 17.6412C3.66675 18.296 3.9488 18.8573 4.5129 19.1379C5.35905 19.6056 7.2394 20.1667 11.0001 20.1667C14.7608 20.1667 16.6411 19.6056 17.4872 19.1379C17.9573 18.8573 18.3334 18.296 18.3334 17.6412C18.3334 14.8351 16.077 12.6837 13.3505 12.6837Z"
                            fill="black" fillOpacity="0.35" />
                    </svg>
                    <span>{t('profile')}</span>
                </div>
                <div className={`mobile-nav-item ${isActive('/favorites') ? 'active' : ''}`} onClick={() => navigate('/favorites')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path
                            d="M1.83325 8.37568C1.83325 12.8333 5.51773 15.2088 8.21484 17.335C9.16659 18.0853 10.0833 18.7917 10.9999 18.7917C11.9166 18.7917 12.8333 18.0853 13.785 17.335C16.4821 15.2088 20.1666 12.8333 20.1666 8.37568C20.1666 3.91798 15.1247 0.756677 10.9999 5.04225C6.87507 0.756677 1.83325 3.91798 1.83325 8.37568Z"
                            fill="#1C4CAF" />
                    </svg>
                    <span>{t('favorites')}</span>
                </div>
                <div className={`mobile-nav-item ${isActive('/filter') ? 'active' : ''}`} onClick={() => navigate('/filter')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path
                            d="M18.3528 2.75H3.64713C3.27381 2.75029 2.9086 2.85894 2.59583 3.06276C2.28305 3.26657 2.03616 3.55679 1.88511 3.89819C1.73406 4.23959 1.68536 4.6175 1.74491 4.98604C1.80445 5.35458 1.96969 5.69792 2.22057 5.97437L8.5937 12.9834V19.5938C8.59375 19.723 8.63022 19.8496 8.69893 19.959C8.76763 20.0684 8.86578 20.1563 8.98213 20.2125C9.07512 20.2584 9.17752 20.2819 9.2812 20.2812C9.43745 20.2811 9.58901 20.2278 9.71089 20.13L10.9999 19.0988L13.1484 17.38C13.2288 17.3156 13.2937 17.234 13.3383 17.1412C13.3829 17.0484 13.4061 16.9467 13.4062 16.8438V12.9834L19.7793 5.97437C20.0302 5.69792 20.1954 5.35458 20.255 4.98604C20.3145 4.6175 20.2658 4.23959 20.1148 3.89819C19.9637 3.55679 19.7168 3.26657 19.4041 3.06276C19.0913 2.85894 18.7261 2.75029 18.3528 2.75Z"
                            fill="black" fillOpacity="0.35" />
                    </svg>
                    <span>{t('filter')}</span>
                </div>

            </nav>

            <svg style={{ display: 'none' }}>
                <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5"
                        result="turbulence" />

                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>

                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />

                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100"
                        lighting-color="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>

                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />

                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R"
                        yChannelSelector="G" />
                </filter>
            </svg>

        </>
    );
}